import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AssetDto } from '../../../../../../api/src/asset/models/asset.dto';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-bria-iframe',
  templateUrl: './bria-iframe.component.html',
  styleUrl: './bria-iframe.component.scss'
})
export class BriaIframeComponent implements OnInit {
  @Input() asset: AssetDto;
  @Input() iframeId: string;
  @Output() saveImage: EventEmitter<string> = new EventEmitter<string>();

  public url: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    console.log('ngOnInit', this.asset);
	let briaIframeId = this.iframeId || environment.briaModifyIframeId || '670213b8-875e-43ca-b42a-3c630d4705a6';

	// Parse the iframe id to make sure its not a website address.
	// Look for ?iframeId=babf8f22-e04d-4394-b57e-477746e8f7f6-1 and extract the id.
	if (briaIframeId.includes('http')) {
		const urlParams = new URLSearchParams(briaIframeId.split('?')[1]);
		briaIframeId = urlParams.get('iframeId') || briaIframeId;
	}

	const unsafeUrl = `https://prod.iframe.platform.bria.ai/?iframeId=${briaIframeId}&vhash=8679a552aa79cc96&sourceDomain=${window.location.origin}&imageUrl=${this.asset.assetPath}`;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);

    // Add event listener for postMessage
    window.addEventListener('message', this.handlePostMessage.bind(this), false);
  }

  ngOnDestroy(): void {
    // Remove event listener when the component is destroyed
    window.removeEventListener('message', this.handlePostMessage.bind(this), false);
  }

  handlePostMessage(event: MessageEvent): void {
    // Ensure the message is from the expected origin
    if (event.origin !== 'https://prod.iframe.platform.bria.ai') {
      return;
    }

	switch(event.data.type) {
		case 'Bria_ImageSave':
			console.log('Image saved:', event.data);
			this.saveImage.emit(event.data?.message?.imageUrl);
			break;
	}

  }
}
